var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.currentComponent,{ref:"currentComponent",tag:"component"}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showOverlay),expression:"showOverlay"}],staticClass:"overlay",on:{"click":_vm.resetPrompts}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }